import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Skeleton com dimensões fixas para ProfileOverview
 * Mantém mesmo height do componente real para evitar CLS
 */
export function ProfileCardSkeleton() {
  return (
    <Card className="shadow-lg min-h-[280px]">
      <CardHeader className="space-y-1 px-4 sm:px-6">
        <Skeleton className="h-7 w-32" />
      </CardHeader>
      <CardContent className="px-4 sm:px-6 space-y-4">
        {/* Progress bar */}
        <div className="space-y-2">
          <div className="flex justify-between">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-4 w-12" />
          </div>
          <Skeleton className="h-2 w-full rounded-full" />
        </div>
        
        {/* Profile header */}
        <div className="flex items-start gap-4 pt-4">
          <Skeleton className="h-16 w-16 rounded-full shrink-0" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-5 w-40" />
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-24" />
          </div>
        </div>
        
        {/* Bio/Description */}
        <div className="space-y-2 pt-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-4/5" />
        </div>
      </CardContent>
    </Card>
  );
}
